// extracted by mini-css-extract-plugin
export var colorSquare = "_qm-0";
export var danger = "_qm-5";
export var lightPink = "_qm-8";
export var neutralBlue = "_qm-7";
export var neutralYellow = "_qm-6";
export var normal = "_qm-1";
export var primary = "_qm-2";
export var primaryLight = "_qm-3";
export var solidBlack = "_qm-g";
export var solidGreen = "_qm-b";
export var solidLightBlue = "_qm-d";
export var solidNavy = "_qm-c";
export var solidOrange = "_qm-f";
export var solidPink = "_qm-e";
export var solidRed = "_qm-9";
export var solidYellow = "_qm-a";
export var success = "_qm-4";